import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            加入讨论，和千万剧迷一起聊剧
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, index) => (
            <div
              key={index}
              className={`group flex items-center gap-3 px-5 py-3 rounded-lg cursor-pointer transition-all duration-200 hover:scale-105 ${
                topic.hot
                  ? 'bg-primary-100/80 text-primary-800'
                  : 'bg-background-50 text-foreground-700 hover:bg-background-200/70'
              }`}
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center text-accent-500 flex-shrink-0">
                  <i className="ri-fire-line text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium whitespace-nowrap">
                #{topic.name}
              </span>
              <span className={`text-xs font-medium whitespace-nowrap ${
                topic.hot ? 'text-primary-600' : 'text-foreground-400'
              }`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}